export const unknown = "Unknown";
export const pathogenicVeryStrong = "Pathogenic Very Strong";
export const pathogenicStrong = "Pathogenic Strong";
export const pathogenicModerate = "Pathogenic Moderate";
export const pathogenicSupporting = "Pathogenic Supporting";
export const benignVeryStrong = "Benign Very Strong";
export const benignStrong = "Benign Strong";
export const benignModerate = "Benign Moderate";
export const benignSupporting = "Benign Supporting";
export const uncertain = "Uncertain";
